import { BASEMAPS } from '@carto/react-basemaps'
import { LayerGroup } from '@carto/kepler.gl/reducers'

import { MapStyleType, GoogleMapsMapTypeId, BuilderBasemapStyle } from '../../types'

import cartoVoyagerIcon from 'assets/img/basemaps/carto-voyager.png'
import cartoPositronIcon from 'assets/img/basemaps/carto-positron.png'
import cartoDarkMatterIcon from 'assets/img/basemaps/carto-dark-matter.png'

import gmapsRoadmapIcon from 'assets/img/basemaps/gmaps-roadmap.png'
import gmapsSatelliteIcon from 'assets/img/basemaps/gmaps-satellite.png'
import gmapsHybridIcon from 'assets/img/basemaps/gmaps-hybrid.png'
import gmapsTerrainIcon from 'assets/img/basemaps/gmaps-terrain.png'
import { createDefaultVisibleLayerGroups } from 'features/builder/model/basemap'

export const LAYER_GROUPS: LayerGroup[] = [
  {
    slug: 'label',
    filter: ({ id }: { id: string }) =>
      Boolean(id.match(/(?=(label|_label|place-|place_|poi-|poi_|watername_|roadname_|housenumber))/)),
    defaultVisibility: true
  },
  {
    slug: 'road',
    filter: ({ id }: { id: string }) => Boolean(id.match(/(?=(road|railway|tunnel|street|bridge))(?!.*label)/)),
    defaultVisibility: true
  },
  {
    slug: 'border',
    filter: ({ id }: { id: string }) => Boolean(id.match(/border|boundaries|boundary_/)),
    defaultVisibility: false
  },
  {
    slug: 'building',
    filter: ({ id }: { id: string }) => Boolean(id.match(/building/)),
    defaultVisibility: true
  },
  {
    slug: 'water',
    filter: ({ id }: { id: string }) => Boolean(id.match(/(?=(water|stream|ferry))/)),
    defaultVisibility: true
  },
  {
    slug: 'land',
    filter: ({ id }: { id: string }) => Boolean(id.match(/(?=(parks|landcover|industrial|sand|hillshade|park_))/)),
    defaultVisibility: true
  }
]

export const defaultVisibleLayerGroups = createDefaultVisibleLayerGroups(LAYER_GROUPS)

export const DEFAULT_MAP_STYLE = 'positron'
export const DEFAULT_MAP_STYLE_PLACEHOLDER = ':default:'

const defaultMapStyles: BuilderBasemapStyle[] = [
  {
    type: MapStyleType.MAPLIBRE,
    id: 'positron',
    label: 'Positron',
    url: BASEMAPS.positron.options.mapStyle,
    icon: cartoPositronIcon,
    layerGroups: LAYER_GROUPS
  },
  {
    type: MapStyleType.MAPLIBRE,
    id: 'dark-matter',
    label: 'Dark matter',
    url: BASEMAPS['dark-matter'].options.mapStyle,
    icon: cartoDarkMatterIcon,
    layerGroups: LAYER_GROUPS
  },
  {
    type: MapStyleType.MAPLIBRE,
    id: 'voyager',
    label: 'Voyager',
    url: BASEMAPS.voyager.options.mapStyle,
    icon: cartoVoyagerIcon,
    layerGroups: LAYER_GROUPS
  },
  {
    type: MapStyleType.GOOGLE_MAPS,
    id: 'roadmap',
    label: 'Roadmap',
    style: {
      type: MapStyleType.GOOGLE_MAPS,
      options: {
        mapId: '3754c817b510f791'
      }
    },
    icon: gmapsRoadmapIcon,
    layerGroups: []
  },
  {
    type: MapStyleType.GOOGLE_MAPS,
    id: 'google-positron',
    label: 'Positron',
    style: {
      type: MapStyleType.GOOGLE_MAPS,
      options: {
        mapId: 'ea84ae4203ef21cd'
      }
    },
    icon: cartoPositronIcon,
    layerGroups: []
  },
  {
    type: MapStyleType.GOOGLE_MAPS,
    id: 'google-dark-matter',
    label: 'Dark Matter',
    style: {
      type: MapStyleType.GOOGLE_MAPS,
      options: {
        mapId: '2fccc3b36c22a0e2'
      }
    },
    icon: cartoDarkMatterIcon,
    layerGroups: []
  },
  {
    type: MapStyleType.GOOGLE_MAPS,
    id: 'google-voyager',
    label: 'Voyager',
    style: {
      type: MapStyleType.GOOGLE_MAPS,
      options: {
        mapId: '885caf1e15bb9ef2'
      }
    },
    icon: cartoVoyagerIcon,
    layerGroups: []
  },
  {
    type: MapStyleType.GOOGLE_MAPS,
    id: 'satellite',
    label: 'Satellite',
    style: {
      type: MapStyleType.GOOGLE_MAPS,
      options: {
        mapTypeId: GoogleMapsMapTypeId.SATELLITE
      }
    },
    icon: gmapsSatelliteIcon,
    layerGroups: []
  },
  {
    type: MapStyleType.GOOGLE_MAPS,
    id: 'hybrid',
    label: 'Hybrid',
    style: {
      type: MapStyleType.GOOGLE_MAPS,
      options: {
        mapTypeId: GoogleMapsMapTypeId.HYBRID
      }
    },
    icon: gmapsHybridIcon,
    layerGroups: []
  },
  {
    type: MapStyleType.GOOGLE_MAPS,
    id: 'terrain',
    label: 'Terrain',
    style: {
      type: MapStyleType.GOOGLE_MAPS,
      options: {
        mapTypeId: GoogleMapsMapTypeId.TERRAIN
      }
    },
    icon: gmapsTerrainIcon,
    layerGroups: []
  }
]

// Roadmap mapId, to be used as a base with mapTypeId,
// otherwise with mapTypeId only the Terrain style is incomplete
export const GOOGLE_MAPS_DEFAULT_MAP_ID = '3754c817b510f791'

export default defaultMapStyles
